export default __webpack_public_path__ + "static/testimonialSmall-18ce8e32eda8e82b4ced282f35bc4938.jpg";